// Portuguese text constants following Rule #4
export const auditTexts = {
  title: "Trilha de Auditoria",
  subtitle: "Histórico de alterações do sistema",

  filters: {
    search: "Buscar por usuário...",
    table: "Tabela",
    action: "Ação",
    dateRange: "Período",
    showDeleted: "Mostrar excluídos",
    allTables: "Todas as tabelas",
    allActions: "Todas as ações",
    startDate: "Data inicial",
    endDate: "Data final",
  },

  actions: {
    CREATE: "Criação",
    UPDATE: "Atualização",
    DELETE: "Exclusão",
    RESTORE: "Restauração",
  },

  tables: {
    properties: "Propriedades",
    clients: "Clientes",
    profiles: "Proprietários",
    maintenance_fees: "Taxas de Manutenção",
  },

  columns: {
    timestamp: "Data/Hora",
    user: "Usuário",
    table: "Tabela",
    action: "Ação",
    record: "Registro",
    changes: "Alterações",
  },

  messages: {
    noData: "Nenhum registro de auditoria encontrado",
    loading: "Carregando trilha de auditoria...",
    error: "Erro ao carregar dados de auditoria",
    accessDenied: "Acesso restrito a administradores",
    sessionExpired: "Sessão expirada. Faça login novamente.",
  },

  pagination: {
    showing: "Exibindo",
    of: "de",
    records: "registros",
    previous: "Anterior",
    next: "Próximo",
    first: "Primeira",
    last: "Última",
  },
};
